import { map } from "rxjs/operators";
import { DELETE, GET, POST, PUT } from "../../../module/services/fetch";
import { ICreateUserBody } from "./constants";

export const fetchGetRolesRequest = () =>
  GET(`external-portal/findRoles`).pipe(map((response: any) => response));

export const fetchGetOffices = () =>
  GET(`external-portal/admin/office`).pipe(map((response: any) => response));

export const fetchGetCompanies = () =>
  GET(`external-portal/admin/company`).pipe(map((response: any) => response));

export const fetchOrganizationalUnitsRequest = (payload: any) => {
  const { roles, request } = payload;
  const req = request ? request : {};
  return POST(`ou/find?roles=${roles}`, req).pipe(
    map((response: any) => response)
  );
};

export const fetchOrganizationalUnitsBySelectedRolesRequest = (
  request: any
) => {
  const req = request ? request : {};
  return POST("ou/find", req).pipe(map((response: any) => response));
};

export const fetchManagersRequest = (request: any = {}) => {
  const req = request ? request : {};
  return POST("user/manager/find", req).pipe(map((response: any) => response));
};

export const fetchReferralsRequest = (request: any = {}) => {
  const req = request ? request : {};
  //w1 - Project Metro
  return POST("external-portal/user/search", req).pipe(map((response: any) => response));
};

export const fetchPaginatedUserRequest = (payload: any) => {
  const { roles, body, sortBy } = payload;
  return POST(
    `external-portal/user/find?roles=${roles}${
      sortBy && sortBy.length > 0
        ? `&sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : ""
    }`,
    body
  ).pipe(map((response: any) => response));
};

export const fetchUpdateUserInfo = (userCode: string, body: any) =>
  PUT(`external-portal/user/${userCode}`, body).pipe(
    map((response: any) => response)
  );

export const fetchGetUserAttachmentsInfo = (payload: any) => {
  const { roles, userCode } = payload;
  return GET(
    `external-portal/user/${userCode}/attachments?roles=${roles}`
  ).pipe(map((response: any) => response));
};

export const fetchGetUserAdminLettersInfo = (payload: any) => {
  const { roles, userCode } = payload;
  return GET(
    `external-portal/user/${userCode}/admin-letters?roles=${roles}`
  ).pipe(map((response: any) => response));
};

export const fetchGetCompaniesCountToBeValidated = (roles: any) =>
  GET(`external-portal/user/companies/count?roles=${roles}`).pipe(
    map((response: any) => response)
  );

export const fetchGetUsersValidationInfo = (payload: any) =>
  GET(`external-portal/user/validation?roles=${payload}`).pipe(
    map((response: any) => response)
  );

export const validateUsersService = (payload: {
  role: string;
  userCode: string[];
  newRelationshipEndDate?: string;
}) => {
  const { newRelationshipEndDate, role, userCode } = payload;
  return POST(
    `external-portal/validateUser?roles=${role}&userCodes=${userCode}${
      newRelationshipEndDate
        ? `&newRelationshipEndDate=${newRelationshipEndDate}`
        : ""
    }`
  ).pipe(map((response: any) => response));
};

export const fetchUploadAttachmentToAdminLetters = (payload: any) => {
  const { roles, body } = payload;
  return POST(
    `external-portal/user/admin-letters?roles=${roles}`,
    body,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));
};

export const fetchUploadAttachmentToUsers = (payload: any) => {
  const { roles, body } = payload;
  return POST(
    `external-portal/user/attachments?roles=${roles}`,
    body,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));
};

export const fetchBlockUser = (payload: any) => {
  const { roles, userCode } = payload;
  return POST(
    `external-portal/blockUser?userCodes=${userCode}&roles=${roles}`
  ).pipe(map((response: any) => response));
};

export const fetchRenewUser = (payload: any) => {
  const { roles, newRelationshipEndDate, body } = payload;
  return POST(
    `external-portal/renewUser?roles=${roles}&newRelationshipEndDate=${newRelationshipEndDate}`,
    body
  ).pipe(map((response: any) => response));
};

export const fetchRenewUserAdmin = (payload: any) => {
  const { roles, newRelationshipEndDate, body } = payload;
  return POST(
    `external-portal/renewUser?roles=${roles}&newRelationshipEndDate=${newRelationshipEndDate}`,
    body
  ).pipe(map((response: any) => response));
};

export const fetchReactivateOutsourcer = (payload: any) => {
  const { roles, body } = payload;
  return POST(`external-portal/reactivateUser?roles=${roles}`, body).pipe(
    map((response: any) => response)
  );
};

export const fetchReactivateConsultant = (payload: any) => {
  const { roles, body } = payload;
  return POST(`external-portal/reactivateUser?roles=${roles}`, body).pipe(
    map((response: any) => response)
  );
};

export const fetchReactivateUser = (payload: any) => {
  const { roles, body } = payload;
  return POST(`external-portal/reactivateUser?roles=${roles}`, body).pipe(
    map((response: any) => response)
  );
};

export const fetchReactivateAdmin = (payload: any) => {
  const { roles, body } = payload;
  return POST(`external-portal/reactivateUser?roles=${roles}`, body).pipe(
    map((response: any) => response)
  );
};

export const fetchTerminateSecurity = (payload: any) => {
  const { roles, userCode, note } = payload;
  return POST(
    `external-portal/terminateUser?userCodes=${userCode}&roles=${roles}&note=${note}`
  ).pipe(map((response: any) => response));
};

export const fetchTerminateOutsourcer = (payload: any) => {
  const { roles, userCode } = payload;
  return POST(
    `external-portal/terminateOutsourcer?userCodes=${userCode}&roles=${roles}`
  ).pipe(map((response: any) => response));
};

export const fetchTerminateConsultant = (payload: any) => {
  const { roles, userCode } = payload;
  return POST(
    `external-portal/terminateConsultant?userCodes=${userCode}&roles=${roles}`
  ).pipe(map((response: any) => response));
};

export const fetchDisableOutsourcer = (payload: any) => {
  const { roles, userCode } = payload;
  return POST(
    `external-portal/disableOutsourcer?userCodes=${userCode}&roles=${roles}`
  ).pipe(map((response: any) => response));
};

export const fetchDisableConsultant = (payload: any) => {
  const { roles, userCode } = payload;
  return POST(
    `external-portal/disableConsultant?userCodes=${userCode}&roles=${roles}`
  ).pipe(map((response: any) => response));
};

export const fetchEnableBadgeToUser = (payload: any) => {
  const { roles, userCode, note, idSede } = payload;
  return POST(
    `external-portal/user/badge/${userCode}?roles=${roles}&note=${note}&idSede=${idSede}`
  ).pipe(map((response: any) => response));
};

export const fetchSaveSocietyValidation = (payload: any) => {
  const { roles, body } = payload;
  return POST(`external-portal/user/validation?roles=${roles}`, body).pipe(
    map((response: any) => response)
  );
};

export const fetchGetUserWithAlreadyExistingFiscalCode = (payload: any) => {
  const { roles, fiscalCode, userType } = payload;
  return GET(
    `external-portal/user/fiscal-code/${fiscalCode}?roles=${roles}${
      userType && userType !== "" ? `&userType=${userType}` : ""
    }`
  ).pipe(map((response: any) => response));
};

export const fetchDeleteAttachment = (payload: any) => {
  const { attachmentId, roles } = payload;
  return DELETE(`external-portal/${attachmentId}?roles=${roles}`).pipe(
    map((response: any) => response)
  );
};

export const fetchGetFieldVisibility = (roles: any) =>
  GET(`external-portal/fieldVisibility?roles=${roles}`).pipe(
    map((response: any) => response)
  );

export const fetchGetButtons = (roles: any) =>
  GET(`external-portal/buttons/roles?roles=${roles}`).pipe(
    map((response: any) => response)
  );

export const fetchGetComboOptions = (fieldPath: string) => {
  return GET(`external-portal/comboOptions/${fieldPath}`).pipe(
    map((response: any) => response)
  );
};

export const fetchInsertUser = (roles: any, body: ICreateUserBody) =>
  POST(`external-portal/user?roles=${roles}`, body).pipe(
    map((response: any) => response)
  );

export const fetchUpdateUser = (
  userCode: string,
  roles: any,
  body: ICreateUserBody
) =>
  PUT(`external-portal/user/${userCode}?roles=${roles}`, body).pipe(
    map((response: any) => response)
  );

export const fetchUserTypeThatCanBeCreated = (roles: any) =>
  GET(`external-portal/new-user-type?roles=${roles}`).pipe(
    map((response: any) => response)
  );
